<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <h2 class="subtitle">Récapitulatif de votre commande : {{order.service.name}}</h2>
        <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat.</p>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <hr style="border: none;border-bottom: 1px solid #e2e2e2;" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <order-detail />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <hr style="border: none;border-bottom: 1px solid #e2e2e2;" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-btn text @click="prevStep()" class="themed">
          <v-icon left>mdi-arrow-left</v-icon>Modifier ma commande
        </v-btn>
      </v-col>
      <v-col cols="6" class="text-right d-flex">
        <v-spacer></v-spacer>
        <div>
          <h2
            class="subtitle"
          >Total: {{(order.amount) ? $format.money(order.amount): $format.money(order.price)}}</h2>
          <v-checkbox v-model="terms" :errorMessages="termsError">
            <template v-slot:label>
              <div>
                J’accepte les
                <a
                  target="_blank"
                  href="/static/terms"
                  @click.stop
                >conditions générales</a> de ventes Marketpro
              </div>
            </template>
          </v-checkbox>
          <v-btn class="primary themed" @click="placeOrder()">Commande</v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import OrderDetail from "../../components/services/OrderDetail";
export default {
  data: function() {
    return {
      terms: false,
      termsError: []
    };
  },
  components: {
    OrderDetail
  },
  computed: {
    ...mapGetters("orderForm", ["order"])
  },
  methods: {
    ...mapActions("orderForm", ["prevStep", "submit"]),
    placeOrder() {
      this.termsError = [];
      if (this.terms) {
        this.submit();
      } else {
        this.termsError.push(
          "Merci de valider les conditions générales pour placer un ordre"
        );
      }
    }
  }
};
</script>

<style>
</style>